module.exports = __webpack_public_path__ + "img/onboarding0.e8851551.png";